module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ad9839e7cd5b54d32b3.worker.js");
};